import React from "react";
import { Box } from "@mui/material";
import { themeConstants } from "../../theme";
import { useTranslation } from "react-i18next";

export const MediaKitStatusPill: React.FC<{ active: boolean }> = ({
  active,
}) => {
  const { t } = useTranslation("mediaKit");
  return (
  <Box
    component="span"
    sx={{
      display: "inline-flex",
      alignItems: "center",
      gap: 0.75,
      px: 1,
      py: 0.5,
      borderRadius: themeConstants.border.radius,
      bgcolor: "background.paper",
      border: "1px solid",
      borderColor: "divider",
      flexShrink: 0,
    }}
  >
    <Box
      component="span"
      aria-hidden
      sx={{
        width: 6,
        height: 6,
        borderRadius: "50%",
        bgcolor: active ? "success.main" : "text.disabled",
      }}
    />
    <Box
      component="span"
      sx={{
        fontSize: "0.75rem",
        lineHeight: 1.25,
        fontWeight: 500,
        color: active ? "text.primary" : "text.secondary",
        userSelect: "none",
      }}
    >
      {active ? t("active") : t("inactive")}
    </Box>
  </Box>
  );
};
